module.exports = __webpack_public_path__ + "img/eicraproIcon.c47e00d0.svg";